import { api } from "@services/baseURL";

export const SaveUsuario = async (data) => {
  try {
    const response = await api.post('Usuario', data);
    return response.data;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao salvar usuario:', parsed);
    throw error;
  }
};

export const UpdateUsuario = async (id, data) => {
  try {
    const response = await api.patch(`Usuario/${id}`, data);
    return response.data;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao atualizar usuário:', parsed);
    throw error;
  }
};

export const DeleteUsuario = async (id) => {
  try {
    await api.delete(`Usuario/${id}`);
    return true;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao deletar usuário:', parsed);
    throw error;
  }
};

export const GetAllUsuarios = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('Usuario', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao buscar todos usuários:', parsed);
    throw error;
  }
};

export const GetByIdUsuario = async (id) => {
  try {
    const response = await api.get(`Usuario/${id}`);
    return response.data;
  } catch (error) {
    const parsed = error.parsed || {};
    console.error('Erro ao buscar usuario pelo id:', parsed);
    throw error;
  }
};

export default {
  SaveUsuario,
  UpdateUsuario,
  DeleteUsuario,
  GetByIdUsuario,
  GetAllUsuarios,
};